export default __webpack_public_path__ + "static/media/leader.162da65d.svg";